import { render } from "./AppVersion.vue?vue&type=template&id=24914765&scoped=true"
import script from "./AppVersion.vue?vue&type=script&lang=js"
export * from "./AppVersion.vue?vue&type=script&lang=js"

import "./AppVersion.vue?vue&type=style&index=0&id=24914765&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24914765"]])

export default __exports__